import api from './api';
import { Customer } from '../types/types';

export const customerService = {
    // Get all customers
    getAllCustomers: async (): Promise<Customer[]> => {
        const response = await api.get<any[]>('/customers');
        // Map backend PascalCase to frontend camelCase
        return response.data.map((customer: any) => ({
            id: customer.id,
            name: customer.firstName,
            lastName: customer.lastName,
            email: customer.email,
            phone: customer.phoneNumber,
            address: customer.address
        }));
    },

    // Get customer by ID
    getCustomerById: async (id: number): Promise<Customer> => {
        const response = await api.get<any>(`/customers/${id}`);
        // Map backend PascalCase to frontend camelCase
        return {
            id: response.data.id,
            name: response.data.firstName,
            lastName: response.data.lastName,
            email: response.data.email,
            phone: response.data.phoneNumber,
            address: response.data.address
        };
    },

    // Create new customer
    createCustomer: async (customer: Partial<Customer>): Promise<Customer> => {
        // Map frontend property names to backend (PascalCase)
        const payload = {
            FirstName: customer.name,
            LastName: customer.lastName,
            Email: customer.email || '',
            PhoneNumber: customer.phone || '',
            Address: customer.address || ''
        };
        const response = await api.post<any>('/customers', payload);
        // Map response back to frontend format
        return {
            id: response.data.id,
            name: response.data.firstName,
            lastName: response.data.lastName,
            email: response.data.email,
            phone: response.data.phoneNumber,
            address: response.data.address
        };
    },

    // Update customer
    updateCustomer: async (id: number, customer: Partial<Customer>): Promise<void> => {
        // Map frontend property names to backend (PascalCase)
        const payload = {
            Id: id,
            FirstName: customer.name,
            LastName: customer.lastName,
            Email: customer.email || '',
            PhoneNumber: customer.phone || '',
            Address: customer.address || ''
        };
        await api.put(`/customers/${id}`, payload);
    },

    // Delete customer
    deleteCustomer: async (id: number): Promise<void> => {
        await api.delete(`/customers/${id}`);
    },
};
